{
  "INTEGRATION_APPS": {
    "FETCHING": "Λήψη Indegrations",
    "NO_HOOK_CONFIGURED": "Δεν υπάρχουν {integrationId} integrations ρυθμισμένες σε αυτόν το λογαριασμό.",
    "HEADER": "Εφαρμογές",
    "STATUS": {
      "ENABLED": "Ενεργό",
      "DISABLED": "Ανενεργό"
    },
    "CONFIGURE": "Διαμόρφωση",
    "ADD_BUTTON": "Προσθήκη νέου hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Επιβεβαίωση Διαγραφής",
        "ACCOUNT": "Αποσύνδεση"
      },
      "MESSAGE": {
        "INBOX": "Είσαστε σίγουροι για την διαγραφή?",
        "ACCOUNT": "Είστε βέβαιοι ότι θα αποσυνδεθείτε;"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ναι, Διέγραψε το",
        "ACCOUNT": "Ναι, Αποσύνδεση"
      },
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "API": {
        "SUCCESS_MESSAGE": "Το hook διαγράφηκε επιτυχώς",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      }
    },
    "LIST": {
      "FETCHING": "Λήψη Integrations",
      "INBOX": "Εισερχόμενα",
      "EDIT": {
        "BUTTON_TEXT": "Επεξεργασία"
      },
      "DELETE": {
        "BUTTON_TEXT": "Διαγραφή"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Επιλογή Εισερχομένων",
          "PLACEHOLDER": "Επιλογή Εισερχομένων"
        },
        "SUBMIT": "Δημιουργία",
        "CANCEL": "Άκυρο"
      },
      "API": {
        "SUCCESS_MESSAGE": "Το Integration hook προστέθηκε επιτυχώς",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      }
    },
    "EDIT": {
      "TITLE": "Επεξεργασία {name}",
      "FORM": {
        "SUBMIT": "Ενημέρωση",
        "CANCEL": "Άκυρο"
      },
      "API": {
        "SUCCESS_MESSAGE": "Το hook ενσωμάτωσης ενημερώθηκε επιτυχώς",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η σύνδεση με τον διακομιστή συνομιλίας, Παρακαλώ προσπαθήστε ξανά αργότερα"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Σύνδεση"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Αποσύνδεση"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Συγχρονισμός email και web chat με τον λογαριασμό daktela σας.",
      "RETINO": "Το Retino φέρνει τάξη στη διαχείριση επιστροφών και αξιώσεων.",
      "MAILSHIP": "Το Mailship είναι ένα σύστημα διαχείρισης αποθήκης και εκτέλεσης παραγγελιών. Αναζητήστε την κατάσταση παραγγελίας, την παρακολούθηση αποστολής και λεπτομέρειες αποστολής.",
      "RAYNET": "Συνδέστε τον λογαριασμό σας Raynet CRM για πρόσβαση στα δεδομένα των πελατών σας. Προσθέστε μια σύνδεση με το όνομα χρήστη και το API token του Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Δοκιμή σύνδεσης",
      "SUCCESS": "Επιτυχής σύνδεση",
      "ERROR": "Η σύνδεση απέτυχε. Ελέγξτε τα διαπιστευτήριά σας."
    }
  }
}
